import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-maaich-black flex flex-col items-center justify-center p-5 text-center">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
      >
        <h1 className="text-9xl font-display italic text-maaich-lime mb-4">404</h1>
        <h2 className="text-4xl md:text-6xl font-display uppercase italic text-white mb-8">Pagina non trovata</h2>
        <p className="text-white/60 font-body mb-12 max-w-md mx-auto">
          Lo spazio che cercavi è già stato sgomberato! Torna in homepage per richiedere il tuo preventivo.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/" className="bg-white text-black font-display uppercase italic px-8 py-4 hover:bg-maaich-lime transition-colors">
            Torna alla Home
          </Link>
          <a href="https://wa.me/393921037894" className="bg-maaich-lime text-black font-display uppercase italic px-8 py-4 hover:bg-white transition-colors flex items-center justify-center gap-2">
            <SafeIcon icon={FiIcons.FiMessageCircle} /> Scrivici ora
          </a>
        </div>
      </motion.div>
    </div>
  );
}